import { getAppointmentOperationalStatus } from 'constants/appointmentStatus.constant'

export const APPOINTMENT_STATUS_NOTE_MAX_LENGTH = 1000

export const getAppointmentStatusInitialValues = (appointment) => ({
    status: getAppointmentOperationalStatus(appointment),
    note:
        typeof appointment?.appointmentStatusNote === 'string'
            ? appointment.appointmentStatusNote
            : '',
})

export const buildAppointmentStatusPayload = (status, note) => {
    const normalizedNote = typeof note === 'string' ? note.trim() : ''

    return {
        status,
        ...(normalizedNote ? { note: normalizedNote } : {}),
    }
}

export const getAppointmentStatusHistory = (appointment) => {
    if (!Array.isArray(appointment?.appointmentStatusHistory)) return []

    return appointment.appointmentStatusHistory
        .filter((entry) => entry && typeof entry.status === 'string')
        .slice()
        .reverse()
}

export const getAppointmentStatusActorLabel = (changedBy) => {
    if (!changedBy || typeof changedBy !== 'object') return ''

    if (typeof changedBy.fullName === 'string' && changedBy.fullName.trim()) {
        return changedBy.fullName.trim()
    }

    return [changedBy.lastName, changedBy.firstName]
        .filter((value) => typeof value === 'string' && value.trim())
        .map((value) => value.trim())
        .join(' ')
}
